// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-container {
  /* background-color: #fff;
    
    z-index: 99;
    position: fixed;
    width: 100px;
    padding: 10px;
    top: 50%;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    left: 50%;
    margin-top: -100px; 
    margin-left: -50px;
    border-radius: 0.5rem; */
  background-color: #fff; /* White background for the spinner */
  z-index: 99; /* Ensure it appears on top of the overlay */
  padding: 10px;
  border-radius: 0.5rem;
  /* Center the spinner container */
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner-container p {
  text-align: center;
  margin: 5px 0 0 0;
}

#upperbar {
  animation: upperBar linear;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  transform-origin: center;
  transform-box: border-box;
}

#middlebar {
  animation: middlebar ease;

  animation-duration: 2s;
  animation-iteration-count: infinite;
  transform-origin: center;
  transform-box: border-box;
}

#bottombar {
  animation: bottombar ease;

  animation-duration: 2s;
  animation-iteration-count: infinite;
  transform-origin: center;
  transform-box: border-box;
}

@keyframes upperBar {
  0% {
    transform: translateX(0px);
  }
  50% {
    transform: translateX(15px);
  }
  100% {
    transform: translateX(0px);
  }
}

@keyframes middlebar {
  0% {
    transform: translateX(-20px);
  }
  50% {
    transform: translateX(0px);
  }
  100% {
    transform: translateX(-20px);
  }
}

@keyframes bottombar {
  0% {
    transform: translateX(0px);
  }
  50% {
    transform: translateX(10px);
  }
  100% {
    transform: translateX(0px);
  }
}

/* Overlay styling */
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Semi-transparent black */
  z-index: 98; /* Make sure it's behind the spinner */
  display: flex;
  justify-content: center;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Loader/Loader.css"],"names":[],"mappings":"AAAA;EACE;;;;;;;;;;;;;;4BAc0B;EAC1B,sBAAsB,EAAE,qCAAqC;EAC7D,WAAW,EAAE,4CAA4C;EACzD,aAAa;EACb,qBAAqB;EACrB,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,mCAAmC;EACnC,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;;EAEzB,sBAAsB;EACtB,mCAAmC;EACnC,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;;EAEzB,sBAAsB;EACtB,mCAAmC;EACnC,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,2BAA2B;EAC3D,WAAW,EAAE,sCAAsC;EACnD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".spinner-container {\n  /* background-color: #fff;\n    \n    z-index: 99;\n    position: fixed;\n    width: 100px;\n    padding: 10px;\n    top: 50%;\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    flex-direction: column;\n    left: 50%;\n    margin-top: -100px; \n    margin-left: -50px;\n    border-radius: 0.5rem; */\n  background-color: #fff; /* White background for the spinner */\n  z-index: 99; /* Ensure it appears on top of the overlay */\n  padding: 10px;\n  border-radius: 0.5rem;\n  /* Center the spinner container */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.spinner-container p {\n  text-align: center;\n  margin: 5px 0 0 0;\n}\n\n#upperbar {\n  animation: upperBar linear;\n  animation-duration: 2s;\n  animation-iteration-count: infinite;\n  transform-origin: center;\n  transform-box: border-box;\n}\n\n#middlebar {\n  animation: middlebar ease;\n\n  animation-duration: 2s;\n  animation-iteration-count: infinite;\n  transform-origin: center;\n  transform-box: border-box;\n}\n\n#bottombar {\n  animation: bottombar ease;\n\n  animation-duration: 2s;\n  animation-iteration-count: infinite;\n  transform-origin: center;\n  transform-box: border-box;\n}\n\n@keyframes upperBar {\n  0% {\n    transform: translateX(0px);\n  }\n  50% {\n    transform: translateX(15px);\n  }\n  100% {\n    transform: translateX(0px);\n  }\n}\n\n@keyframes middlebar {\n  0% {\n    transform: translateX(-20px);\n  }\n  50% {\n    transform: translateX(0px);\n  }\n  100% {\n    transform: translateX(-20px);\n  }\n}\n\n@keyframes bottombar {\n  0% {\n    transform: translateX(0px);\n  }\n  50% {\n    transform: translateX(10px);\n  }\n  100% {\n    transform: translateX(0px);\n  }\n}\n\n/* Overlay styling */\n.spinner-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); /* Semi-transparent black */\n  z-index: 98; /* Make sure it's behind the spinner */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
